enum InvoicingPeriod {
  TODAY = 'today',
  THIS_WEEK = 'thisWeek',
  OLDER = 'older',
}

export default InvoicingPeriod;